import React from 'react'
import '../Common.scss'
import styles from '../Appliances/Appliance.module.scss';
import defaultImage from '../../../assets/default.png'

export default function FalseCeilingPaintView({pageDetails}) {
  const { paintDetails } = pageDetails.metaData || {};
  const { isFirstPage } = pageDetails

  const paintHeaderList=["name", "product_name","area","color"]
  const paintValuesKey=["Name", "Product name", "Area","Color"]

  const getValue =(key,rowData)=>{
    if(key === "color"){
      if(rowData["colorCode"]==="NA" && rowData.hasOwnProperty('thumbUrl')){
        return <div className="fcPaintRowDataContainer"> 
                <div style={{backgroundImage:"url("+rowData["thumbUrl"]+")"}} className="fcWallpaperPaint"></div>
            </div> 
      }else{
        return <div className="fcPaintRowDataContainer"> 
                <p> {rowData[key]}</p> 
                <div style={{backgroundColor:rowData["colorCode"]}} className="fcColorPaint"></div>
        </div> 
      }
    }else{
      return rowData[key]
    }
}
  return (
    <>
        <div className="page-heading">{pageDetails?.name}</div>
         {isFirstPage ? 
         <div className="page-image-container" style={{height:"60%"}}>
            <div className="image-section-container">
                <img crossOrigin="anonymous"  src={pageDetails.images ? pageDetails?.images[0]?.imageUrl : defaultImage} alt="" className="image-view" />
            </div>
        </div>:null}
        <br/>

      { paintDetails ? 
       <>
        <div style={{whiteSpace:'nowrap',marginLeft:'20px'}} >Paint Details</div>
          <div className={styles["appliances-details"]}>
              <div className={styles["details-table-app"]}>
                      <div className={styles["table-row-app"] + " "+ styles['headings']}>
                          {(paintValuesKey || []).map((heading, index)=>{
                              return(
                                  <div className={styles["table-cell-app"]} style={{width:heading==="Color"?"25%":"default%"}}>
                                      {heading}
                                  </div>
                                )
                            })}
                      </div>
                {(paintDetails || []).map((rowData)=>{
                    return(
                        <div className={styles["table-row-app"]}>
                            {(paintHeaderList || []).map(key=>{
                                let value = getValue(key,rowData)
                                return <div className={styles["table-cell-app"]}>
                                        {value ? value : "NA"}
                                </div>
                            })}
                        </div>
                      )
                })}
              </div>
        </div>
      </> : null}
    </>
  )
}
